var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Calendar } from '@hn-ui/icons';
import { styled } from 'styled-components';
import { BlueButton } from '@hn-ui/buttons';
var ScButton = styled(BlueButton).withConfig({ displayName: "ScButton", componentId: "sc-1h86qdb" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 10px;\n"], ["\n  padding: 10px;\n"])));
var DatePickerInput = forwardRef(function (_a, ref) {
    var onClick = _a.onClick;
    return (_jsx(ScButton, __assign({ "aria-label": 'Select a date range', onClick: onClick, ref: ref, fit: true, size: 'small' }, { children: _jsx(Calendar, { size: 20, color: 'black100' }, void 0) }), void 0));
});
export { DatePickerInput };
var templateObject_1;
